export default "__VITE_ASSET__79cQqGLI__"